import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { setupAutoComplete } from './setupAutoComplete.js';
import getAccessToken from '../../api/getAccessToken.ts';
import useBotPagesConfig from '../../hooks/useBotPagesConfig.ts';
import { useMsal } from '@azure/msal-react';
import usePagesUserId from '../../hooks/usePagesUserId.ts';

const Search: React.FC = () => {
    const inputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const { clientId, requiresAuthentication } = useBotPagesConfig();
    const msalInfo = useMsal();
    const pagesUserId = usePagesUserId();

    const getAccessTokenFunc = async () => {
        return await getAccessToken(clientId, msalInfo, requiresAuthentication);
    };

    useEffect(() => {
        if (!inputRef.current) {
            return;
        }

        setupAutoComplete(
            '#autocomplete',
            navigate,
            getAccessTokenFunc,
            pagesUserId
        );

        const handleEnterKey = (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                navigate(
                    `/assistant?searchText=${encodeURIComponent(
                        inputRef.current!.value
                    )}`
                );
            }
        };

        const inputElement = inputRef.current;
        inputElement.addEventListener('keydown', handleEnterKey);

        return () => {
            inputElement.removeEventListener('keydown', handleEnterKey);
        };
    }, [navigate]);

    const handleButtonClick = () => {
        if (inputRef.current) {
            navigate(
                `/assistant?searchText=${encodeURIComponent(
                    inputRef.current.value
                )}`
            );
        }
    };

    return (
        <div className='input-group search-holder'>
            <input
                id='autocomplete'
                className='form-control search-input'
                type='text'
                placeholder='Ask a question...'
                aria-label='Search'
                ref={inputRef}
            />
            <img
                className='search-icon'
                src='/images/search-icon.svg'
                alt='search'
            />
            <button
                id='search'
                className='btn btn-primary rounded-pill'
                type='button'
                onClick={handleButtonClick}
            >
                Help
            </button>
        </div>
    );
};

export default Search;
